
export type { RelationType } from 'api/generated/model';

//#region Permissions
export enum Permission
{
    None = 0,
    View = 1,
    Create = 2,
    Edit = 3,
    Delete = 4,
    All = 99,
}

export enum PermissionColumn {
  //? Tenant
  Tenant = 0,
  Employees = 1,
  Dashboard = 2,
  //? Operational
  Activities = 3,
  Hireds = 4,
  Financial = 5,
  //? Documents
  Documents = 6,
  //? Tax Claimants
  TaxClaimants = 7,
  TaxClaimantDocuments = 8,
  TaxClaimantDocumentsTriage = 9,
  //? Clients
  Clients = 10,
  Departments = 11,
  TaxRegimes = 12,
  ClientDocuments = 13,
  ClientDocumentsTriage = 14,
  //? PaymentPlans
  PaymentPlans = 15,
  Agencies = 16,
  Modalities = 17,
  Installments = 18,
  //? Contracts
  Contracts = 19,
  Witness = 20,
  Partner = 21,
}

//#region Relations

export const RelationsType = [
  'Owner',
  'Employee',
  'Client',
  'TaxClaimant',
] as const;

type IndexOf<T extends readonly unknown[], V, Acc extends unknown[] = []> =
    T extends readonly [infer Head, ...infer Tail]
        ? Head extends V
            ? Acc['length']
            : IndexOf<Tail, V, [...Acc, unknown]>
        : never;

export const RelationTypeEnum = Object.fromEntries(
    RelationsType.map((name, index) => [name, index])
) as { [K in (typeof RelationsType)[number]]: IndexOf<typeof RelationsType, K> };

export const RelationTypeMap = RelationsType.map((title) => ({
    title,
    value: RelationTypeEnum[title],
}));


export enum RelationStatusType {
  Desactive,
  Active,
  Invite,
}
export enum Role {
  Manager,
  Employee,
}

export enum ClientType
{
    Fixed = 0,
    Occasional = 1
}

export enum ValidtyFilter
{
    Inativo = 0,
    Ativo = 1,
    Indefinido = 9
}